
import { isMobile } from "../utils/common";
export default {
    props: ["dataSource"],
    data() {
        return {
            mobile:false,
          
            columns: [
                {
                    title: "STT",
                    dataIndex: "key",
                    key: "key",
                    width: 76,
                    align: "center",
                    customRender: (val, record) => {
                        return <div style="font-weight: bold;">{val}</div>
                    }
                },
                {
                    title: "Tên ngành, mã ngành",
                    dataIndex: "major",
                    key: "major",
                    width: 725,
                    customRender: (val, record) => {
                        return (
                            <div>
                                <div style="font-weight: bold;">
                                    {val?.name}
                                </div>
                                <div>{val?.code}</div>
                            </div>
                        )
                    }
                    // scopedSlots: { customRender: "image-column" },
                },
                {
                    title: "Môn tổ hợp",
                    dataIndex: "subject",
                    key: "subject",
                    width: 232
                }
            ]
        }
    },
    mounted(){
    this.mobile = isMobile();
    },
    methods:{
       
        customRow(record) {
      return {
        on: {
          click: event => {
           this.$emit('major-click',record.major.name)
          }
        }
      };
    }
    }
}
